import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Filter(setIsCMFileFilterPanelOpen: (isCMFileFilterPanelOpen: boolean) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);
  const filterFields = useSelector((state: RootState) => state.contentManagerDirectory.filterFields);
  const filterSections = useSelector((state: RootState) => state.contentManagerDirectory.filterSections);

  const [menuItem_Filter, setMenuItem_Filter] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    setMenuItem_Filter(
      {
        key: "filter",
        disabled: (!filterFields || filterFields?.length === 0) && (!filterSections || filterSections?.length === 0),
        iconProps: { iconName: "Filter" },
        iconOnly: true,
        tooltipHostProps: {
          content: <span>{languageStrings.Filter}</span>
        },
        onClick: () => {
          setIsCMFileFilterPanelOpen(true);
        }
      }
    );
  }, [searchValue, filterFields, filterSections]);

  return {
    menuItem_Filter
  }
}